// ! This file was auto-generated from the esign OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
export const endpoints = {
    adobesignCallback: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Authorization, id: "LIST" }]
    },
    adobesignWebhook: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Webhook, id: "LIST" }]
    },
    adobesignWebhookValidation: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Webhook, id: "LIST" }]
    },
    authorize: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Authorization, id: "LIST" }]
    },
    createIntegration: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Integrations, id: "LIST" }]
    },
    createMultiDocPackage: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    createMultiDocPackageAsync: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    createPackage: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    createPackageInternal: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    deleteIntegration: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Integrations, id: arg.integrationId }, { type: Tags.Integrations, id: "LIST" }]
    },
    deleteIntegrationUserTokens: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Integrations, id: arg.integrationId }, { type: Tags.Integrations, id: "LIST" }]
    },
    docusignCallback: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Authorization, id: "LIST" }]
    },
    docusignWebhook: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Webhook, id: "LIST" }]
    },
    ensureTicketsEligible: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    getIntegrations: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Integrations, id: "LIST" }]
    },
    getIntegrationsInternal: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Integrations, id: "LIST" }]
    },
    getIntegrationUsers: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Integrations, id: arg.integrationId }]
    },
    getPackage: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    getPackageActivities: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    getPackageActivitiesInternal: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    getPackageCertificate: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    getPackageCertificateInternal: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    getPackageDocument: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    getPackageDocumentByTicketAndDocumentId: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Packages, id: arg.ticketId }]
    },
    getPackageDocumentByTicketAndDocumentIdInternal: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Internal_Packages, id: arg.ticketId }]
    },
    getPackageDocumentInternal: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    getPackageRecipients: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    getPackageRecipientsInternal: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    getPackageStatus: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    getPackageStatusInternal: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    getTokenStatus: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Tokens, id: "LIST" }]
    },
    getVendors: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Vendors, id: "LIST" }]
    },
    livenessCheck: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    readinessCheck: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    remindSigner: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    remindSignerInternal: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    signPackage: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    signPackageInternal: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    updateIntegrationType: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Integrations, id: arg.integrationId }, { type: Tags.Integrations, id: "LIST" }]
    },
    viewPackage: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    viewPackageInternal: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    },
    voidPackage: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Packages, id: "LIST" }]
    },
    voidPackageInternal: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Internal_Packages, id: "LIST" }]
    }
} as const;
